// Central runtime config. In production VITE_API_BASE is '' → relative '/api/v1' (same-domain).
const rawBase = import.meta.env.VITE_API_BASE ?? ''

export const API_BASE = rawBase.replace(/\/$/, '')
export const API_PREFIX = '/api/v1'
export const API_URL = `${API_BASE}${API_PREFIX}`

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? ''

// Storage keys. NOTE (A2): the access token is kept in memory only; only the refresh token and a
// non-sensitive user cache are persisted. See SECURITY_NOTES.md.
export const STORAGE_KEYS = {
  refreshToken: 'admin_refresh_token',
  userCache: 'admin_user_data',
} as const
